if (!customElements.get('lpb-card-variants')) {
  customElements.define(
    'lpb-card-variants',
    class LpbCardVariants extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.select = this.querySelector('select');
        try {
          this.data = JSON.parse(this.querySelector('[data-lpb-card-variants-data]').textContent);
        } catch {
          return;
        }
        this.card = this.closest('.lpb-product-card');
        // Only one in-stock variant left: nothing to choose, keep the select out of the way.
        if (this.select && this.select.options.length < 2) this.style.display = 'none';
        this.select?.addEventListener('change', () => this.update(this.select.value));
        if (this.select?.value) this.update(this.select.value);
      }

      update(variantId) {
        const variant = this.data.variants.find((v) => String(v.id) === String(variantId));
        if (!variant || !this.card) return;
        const card = this.card;

        card.querySelectorAll('.lpb-heading-s-title a').forEach((a) => (a.textContent = ` ${variant.name} `));

        const base = this.dataset.productUrl;
        if (base) {
          card.querySelectorAll(`a[href^="${base}"]`).forEach((a) => {
            // Obfuscated links keep the clean product URL in href; the variant URL goes base64-encoded in data-o.
            if (a.classList.contains('obflink')) a.dataset.o = btoa(variant.url);
            else a.setAttribute('href', variant.url);
          });
        }

        this.updateStock(variant);
        this.updatePrice(variant);
        this.updateForm(variant);
      }

      updateStock(variant) {
        const card = this.card;
        card.querySelector('.card')?.classList.toggle('lpb-product-card--sold-out', !variant.available);
        const label = card.querySelector('.lpb-product-card__out-stock-label, .lpb-product-card__available-label');
        if (label) {
          label.classList.toggle('lpb-product-card__out-stock-label', !variant.available);
          label.classList.toggle('lpb-product-card__available-label', variant.available);
          label.textContent = variant.available ? this.data.available : this.data.soldOut;
        }
      }

      updatePrice(variant) {
        const price = this.card.querySelector('.price');
        if (!price) return;
        const onSale = variant.savings > 0;
        price.classList.toggle('price--on-sale', onSale);
        price.classList.toggle('price--sold-out', !variant.available);
        price.classList.remove('price--no-compare');

        const set = (selector, text) => price.querySelectorAll(selector).forEach((el) => (el.textContent = text));
        // `s` is the struck-through compare-at price (volume-pricing cards render it inside .price__regular too)
        set('.price__regular .price-item--regular:not(s)', variant.price);
        set('.price__sale .price-item--sale', variant.price);
        set('.price__sale s .price-item--regular, .price__sale s.price-item--regular, .price__regular s.price-item--regular', variant.compare);
        set('.lpb-badge-percentage', `- ${variant.savings}%`);

        const abo = this.card.querySelector('.lpb-price-abonne');
        if (abo) {
          abo.hidden = onSale;
          const aboPrice = abo.querySelector('[data-abonne-price]');
          if (aboPrice) aboPrice.textContent = variant.abo;
        }
      }

      updateForm(variant) {
        const form = this.card.querySelector('product-form form');
        if (!form) return;
        const input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.disabled = !variant.available;
        }
        const button = form.querySelector('[name="add"]');
        if (button) {
          button.disabled = !variant.available;
          button.toggleAttribute('aria-disabled', !variant.available);
          const label = button.querySelector('span:not(.sold-out-message)');
          if (label) {
            label.innerHTML = variant.available
              ? '<i class="fa-solid fa-basket-shopping-simple"></i>'
              : this.data.soldOut;
          }
        }
      }
    }
  );
}
